var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"diag-marker"},[(_vm.hover)?_c('div',{staticClass:"debug-content"},[_c('pre',[_vm._v(_vm._s(_vm.debug))])]):_vm._e(),_c('q-icon',{attrs:{"name":"las la-atom"},on:{"click":function($event){_vm.hover = !_vm.hover}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }